export default {
  meta: {
    title: $localize`:@@meta.bonuses.title:Бонусы и промокоды`,
    description: $localize`:@@meta.bonuses.desc:Лутай множество бесплатных бонусов каждый день! Хочешь больше халявы? Участвуй в интересной викторине с гарантированными призами на баланс сайта!`
  }
};